// FIXED BusinessUserPayment.js
import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";

const BusinessUserPayment = ({ amount, email, onPaymentComplete, config }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [savePaymentMethod, setSavePaymentMethod] = useState(true);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setProcessing(true);
    setError("");

    let paymentIntentId = null;

    try {
      console.log("Starting business verification payment process");

      // Create payment intent for business verification
      const { data } = await axios.post("/api/business-verification-charge", {
        amount: amount,
        email: email,
      });

      paymentIntentId = data.paymentIntentId;
      console.log("Payment intent created:", paymentIntentId);

      // Create payment method first
      const { error: paymentMethodError, paymentMethod } =
        await stripe.createPaymentMethod({
          type: "card",
          card: elements.getElement(CardElement),
          billing_details: {
            email: email,
          },
        });

      if (paymentMethodError) {
        console.error("Payment method creation error:", paymentMethodError);
        setError(paymentMethodError.message);
        throw new Error(paymentMethodError.message);
      }

      console.log("Payment method created:", paymentMethod.id);

      // Confirm payment with the created payment method
      const { error: confirmError, paymentIntent } =
        await stripe.confirmCardPayment(data.clientSecret, {
          payment_method: paymentMethod.id,
        });

      if (confirmError) {
        console.error("Payment confirmation error:", confirmError);
        setError(confirmError.message);
        throw new Error(confirmError.message);
      }

      if (paymentIntent.status === "succeeded") {
        console.log("Payment succeeded:", paymentIntent.id);

        // Call the completion handler with payment method info
        onPaymentComplete(
          paymentIntent.id,
          paymentMethod.id, // Pass the payment method ID
          savePaymentMethod
        );
      } else {
        throw new Error(`Payment failed with status: ${paymentIntent.status}`);
      }
    } catch (err) {
      console.error("Payment error:", err);

      // If we have a payment intent ID and the error occurred after creation,
      // attempt to refund it automatically
      if (paymentIntentId) {
        console.log("Attempting to refund failed payment:", paymentIntentId);
        try {
          await axios.post("/api/refund-verification-payment", {
            paymentIntentId: paymentIntentId,
            reason: "Payment processing failed",
          });
          console.log("Auto-refund successful for failed payment");
        } catch (refundError) {
          console.error("Auto-refund failed:", refundError);
          // Don't show refund error to user, just log it
        }
      }

      // Better error handling for user display
      let errorMessage = "Payment failed";
      if (err.response?.data?.error) {
        errorMessage = err.response.data.error;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      setProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4">
          Business Account Verification
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          A verification charge of ${amount.toFixed(2)} will be processed and
          immediately refunded after account verification.
        </p>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 rounded-md p-3 mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Card Information
            </label>
            <div className="border rounded-md p-3">
              <CardElement
                options={{
                  style: {
                    base: {
                      fontSize: "16px",
                      color: "#424770",
                      "::placeholder": {
                        color: "#aab7c4",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={savePaymentMethod}
                onChange={(e) => setSavePaymentMethod(e.target.checked)}
                className="mr-2"
              />
              <span className="text-sm text-gray-700">
                Save this payment method for future orders (This will allow
                automatic charging for business orders)
              </span>
            </label>
          </div>

          <div className="flex space-x-3">
            <button
              type="button"
              onClick={() => onPaymentComplete(null, null, false)}
              className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300"
              disabled={processing}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!stripe || processing}
              className="flex-1 bg-green-400 text-white py-2 px-4 rounded-md disabled:opacity-50"
            >
              {processing ? "Processing..." : `Pay $${amount.toFixed(2)}`}
            </button>
          </div>
        </form>

        <div className="mt-4 text-xs text-gray-500">
          <p>
            • Your card will be charged ${amount.toFixed(2)} for verification
          </p>
          <p>• This amount will be automatically refunded after verification</p>
          <p>
            • If you choose to save the payment method, it will be used for
            future business orders
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessUserPayment;

// // new
// // // src/components/BusinessUserPayment.js
// import React, { useState } from "react";
// import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import axios from "axios";

// const BusinessUserPayment = ({ amount, email, onPaymentComplete, config }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [processing, setProcessing] = useState(false);
//   const [error, setError] = useState("");
//   const [savePaymentMethod, setSavePaymentMethod] = useState(true);

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!stripe || !elements) {
//       return;
//     }

//     setProcessing(true);
//     setError("");

//     try {
//       // Create payment intent for business verification
//       const { data } = await axios.post("/api/business-verification-charge", {
//         amount: amount,
//         email: email,
//       });

//       // Confirm payment
//       const { error: confirmError, paymentIntent } =
//         await stripe.confirmCardPayment(data.clientSecret, {
//           payment_method: {
//             card: elements.getElement(CardElement),
//             billing_details: {
//               email: email,
//             },
//           },
//         });

//       if (confirmError) {
//         setError(confirmError.message);
//         setProcessing(false);
//         return;
//       }

//       if (paymentIntent.status === "succeeded") {
//         // Call the completion handler with payment method info
//         onPaymentComplete(
//           paymentIntent.id,
//           paymentIntent.payment_method,
//           savePaymentMethod
//         );
//       }
//     } catch (err) {
//       console.error("Payment error:", err);
//       setError(err.response?.data?.error || "Payment failed");
//       setProcessing(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
//         <h3 className="text-lg font-semibold mb-4">
//           Business Account Verification
//         </h3>
//         <p className="text-sm text-gray-600 mb-4">
//           A verification charge of ${amount.toFixed(2)} will be processed and
//           immediately refunded after account verification.
//         </p>

//         {error && (
//           <div className="bg-red-50 border border-red-200 text-red-600 rounded-md p-3 mb-4">
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Card Information
//             </label>
//             <div className="border rounded-md p-3">
//               <CardElement
//                 options={{
//                   style: {
//                     base: {
//                       fontSize: "16px",
//                       color: "#424770",
//                       "::placeholder": {
//                         color: "#aab7c4",
//                       },
//                     },
//                   },
//                 }}
//               />
//             </div>
//           </div>

//           <div className="mb-4">
//             <label className="flex items-center">
//               <input
//                 type="checkbox"
//                 checked={savePaymentMethod}
//                 onChange={(e) => setSavePaymentMethod(e.target.checked)}
//                 className="mr-2"
//               />
//               <span className="text-sm text-gray-700">
//                 Save this payment method for future orders
//               </span>
//             </label>
//           </div>

//           <div className="flex space-x-3">
//             <button
//               type="button"
//               onClick={() => onPaymentComplete(null, null, false)}
//               className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300"
//               disabled={processing}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={!stripe || processing}
//               className="flex-1  bg-green-400  text-white py-2 px-4 rounded-md disabled:opacity-50"
//             >
//               {processing ? "Processing..." : `Pay $${amount.toFixed(2)}`}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default BusinessUserPayment;

// // the old one but working properly
// //src/components/BusinessUserPayment.js
// import React, { useState } from 'react';
// import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
// import { Alert, AlertDescription } from './ui/alert';
// import { AlertCircle, CheckCircle } from 'lucide-react';
// import axios from 'axios';

// const BusinessUserPayment = ({ amount, email, onPaymentComplete, config }) => {
//   const [processing, setProcessing] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(false);
//   const stripe = useStripe();
//   const elements = useElements();
//   const [saveCard, setSaveCard] = useState(false);
//   const [paymentIntentId, setPaymentIntentId] = useState(false);

// const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!stripe || !elements) {
//       return;
//     }

//     setProcessing(true);
//     setError(null);

//     try {
//       // Create payment intent for business verification
//       const { data: { clientSecret, paymentIntentId: intentId } } = await axios.post('/api/business-verification-charge', {
//         amount,
//         email
//       });

//       // Store the payment intent ID immediately
//       setPaymentIntentId(intentId);

//       // Prepare payment method
//       const cardElement = elements.getElement(CardElement);

//       // Create payment method
//       const { error: paymentMethodError, paymentMethod } = await stripe.createPaymentMethod({
//         type: 'card',
//         card: cardElement,
//       });

//       if (paymentMethodError) {
//         throw new Error(paymentMethodError.message);
//       }

//       // Confirm card payment with the payment method
//       const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
//         payment_method: paymentMethod.id,
//         setup_future_usage: saveCard ? 'off_session' : undefined,
//       });

//       if (stripeError) {
//         throw new Error(stripeError.message);
//       }

//       if (paymentIntent.status === 'succeeded') {
//         setSuccess(true);
//         // Notify parent component that payment was completed successfully
//         onPaymentComplete(paymentIntent.id, saveCard ? paymentMethod.id : null);
//       }
//     } catch (error) {
//       console.error('Payment error:', error);
//       setError(
//         error.response?.data?.error ||
//         error.message ||
//         'An error occurred during payment. Please try again.'
//       );

//       // If there was a payment intent created but confirmation failed, we should refund it
//       if (paymentIntentId) {
//         try {
//           await axios.post('/api/refund-verification-payment', {
//             paymentIntentId,
//             reason: 'Payment confirmation failed'
//           });
//           console.log('Refund initiated for failed payment confirmation');
//         } catch (refundError) {
//           console.error('Failed to refund payment:', refundError);
//         }
//       }
//     }

//     setProcessing(false);
//   };

//   return (
//     <div className="mt-4 p-4 border rounded-md">
//       <h3 className="text-lg font-medium mb-3">Business Account Verification</h3>

//       {success ? (
//         <div className="bg-green-50 p-4 rounded-md flex items-start mb-4">
//           <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 mr-2" />
//           <div>
//             <p className="text-green-700 font-medium">Payment Successful!</p>
//             <p className="text-sm text-green-600">
//               Your verification charge of ${amount.toFixed(2)} has been processed.
//               This amount will be refunded after your account is verified.
//             </p>
//           </div>
//         </div>
//       ) : (
//         <form onSubmit={handleSubmit}>
//           {error && (
//             <Alert variant="destructive" className="mb-4">
//               <AlertCircle className="h-4 w-4" />
//               <AlertDescription>{error}</AlertDescription>
//             </Alert>
//           )}

//           <p className="mb-4 text-sm text-gray-600">
//             A verification charge of ${amount.toFixed(2)} will be applied to verify your business account.
//             This amount will be refunded after verification is complete.
//           </p>

//           <div className="mb-4 p-4 border rounded">
//             <CardElement
//               options={{
//                 style: {
//                   base: {
//                     fontSize: '16px',
//                     color: '#424770',
//                     '::placeholder': {
//                       color: '#aab7c4',
//                     },
//                   },
//                   invalid: {
//                     color: '#9e2146',
//                   },
//                 },
//               }}
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={!stripe || processing}
//             className={`w-full text-white px-6 py-3 rounded-md font-semibold
//               ${(!stripe || processing) ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}`}
//             style={{ backgroundColor: config?.colors.primary || '#aaaaaa'}}
//           >
//             {processing ? 'Processing...' : `Pay $${amount.toFixed(2)}`}
//           </button>
//         </form>
//       )}
//     </div>
//   );
// };

// export default BusinessUserPayment;
